import { Injectable, Inject } from '@angular/core';
import { Http } from '@angular/http';
 import * as models from '../swagger/ecomApi';
 import { BadgeClient } from '../swagger/ecomApi';
 import { Observable } from '../../../node_modules/rxjs';
 import { ApiConfig } from '../../shared/api-config.service';
 import { LoggerService } from '../../shared/logger.service';
 import { Storage } from '@ionic/storage';
import 'rxjs/Rx';


@Injectable()
export class ecomBadgesApi extends BadgeClient {

    constructor( @Inject(Http) http: Http, protected apiConfig: ApiConfig, private log: LoggerService, private storage: Storage) {
        super(http, apiConfig.apiBaseForum);
     }

     GetAllEarnersBadges(userId: number): Observable<models.BadgeModel[]>{
        return this.getAllEarnersBadges(userId);
     }

}


// WEBPACK FOOTER //
// ./src/api/ecom/ecomBadgesApi.ts